module.exports = __webpack_public_path__ + "img/reminder.2881eb59.svg";